<section class="additional-info-card cmnh-card simple">
  <div class="card-body">
    <div class="additional-info-field">
      <app-cmn-textarea [label]="'ADDITIONAL_COMMENTS' | translate" textareaId="comment" name="comment" rows="3"
        maxlength="220" [placeholder]="'ADDITIONAL_COMMENTS_PLACEHOLDER' | translate"
        [(ngModel)]="donorEditCommon.donor.comment" showCharacterCount></app-cmn-textarea>
      @if (donorEditCommon.donor.comment?.length >= 220) {
      <span class="additional-info-error">
        {{ "VALIDATION_CHARACTER_LIMIT" | translate }}
      </span>
      }
      @if (validationError) {
      <p class="additional-info-error">
        {{ validationError | translate }}
      </p>
      }
    </div>
  </div>
</section>